import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import Context from '@bibliocommons/context';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import ExternalSearchPanel from './ExternalSearchPanel';

export function ExternalSearchPanelContainer() {
  const props = {
    currentLibrary: useSelector(selectCurrentLibrary),
    catalogBib: useSelector(selectCatalogBib)
  };
  const { mobileApp } = useContext(Context);

  return !mobileApp && <ExternalSearchPanel {...props} />;
}

export default ExternalSearchPanelContainer;
